import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-arrow-circle-right",
  templateUrl: "./med-icon-arrow-circle-right.component.html",
})
export class MedIconArrowCircleRightComponent extends SvgMixinComponent {}
